import React, { useEffect, useState } from "react";
import useHttp from '../../../../hook/use-http';

function Modal({ apiend, gloablfilter }) {

  const [chartdata, setChartData] = useState([]);
  const { isLoading, error, sendReq: fetchData } = useHttp();

  const appyData = (data) => {
  }

  return (
    <>
      <div className="addEmployee">
        <button type="button" className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#staticBackdrop">Add Employee</button>
        <div className="modal fade" id="staticBackdrop"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="staticBackdropLabel">Modal title</h5>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div className="modal-body">
                ...
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                <button type="button" className="btn btn-primary">Understood</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );




}


export default Modal;